import React from 'react';
import { Check } from 'lucide-react';
export function IncludesSection() {
  return <section className="w-full bg-white py-20 px-6 md:px-8" style={{
    paddingTop: '70px',
    paddingBottom: '70px'
  }} data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <h2 className="text-3xl md:text-4xl font-bold text-text text-center mb-12" data-id="element-145">
          ¿Qué incluye exactamente?
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-146">
          {['El plan Día 1–30 (móvil/iPad-friendly)', 'Checklists mínimos (Mamá/Bebé/Casa)', "'Versión 5 minutos' para días rotos", 'Guiones de emergencia (llanto, noche imposible, comentarios de familia)', 'Plantillas para pedir ayuda sin explicar demasiado', 'Lista corta de básicos (sin compras infinitas)'].map((item, idx) => <div key={idx} className="flex items-start gap-4 p-4 rounded-xl hover:bg-cream transition-colors" data-id="element-147">
              <div className="mt-1 w-6 h-6 rounded-full bg-lavender flex items-center justify-center flex-shrink-0" data-id="element-148">
                <Check className="w-4 h-4 text-white" data-id="element-149" />
              </div>
              <span className="text-lg text-text/90" data-id="element-150">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}